<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Cadastros restritos
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e
        strong  cadastrar
        |  restrições de cadastro em
        strong  Configurações → Cadastros restritos
        | .

      .toast.toast-primary
        | Exige
        strong  Cadastros restritos → Listar
        | . Para incluir ou editar, use
        strong  Cadastros restritos → Criar
        |  e
        strong  Cadastros restritos → Alterar
        | . O botão
        strong  Logs
        |  exige
        strong  Logs → Listar
        | .

      h5.h5 1. Abrir Cadastros restritos
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Clique em
          strong  Cadastros restritos
          | .

      h5.h5 2. Listagem
      p
        | Filtre por
        strong  Documento modelo
        |  e
        strong  Cadastro
        | . Cada registro aparece em um card com tipo/número do cadastro, modelo,
        |  início, fim, protocolo (número/ano), datas e descrição.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de cadastros restritos")
      ol
        li Clique em
          strong  Novo
          |  para cadastrar.
        li No rodapé do card, use
          strong  Logs
          |  ou
          strong  Editar
          | .
        li Use a paginação se houver várias páginas.

      h5.h5 3. Novo ou editar
      figure.manual-figure
        img(:src="imgForm" alt="Formulário de cadastro restrito")
      ol
        li Selecione
          strong  Cadastro
          |  e
          strong  Documento modelo
          |  (na edição o cadastro fica desabilitado).
        li Informe
          strong  Inicia em
          |  (obrigatório),
          strong  Termina em
          |  (opcional) e
          strong  Descrição
          | .
        li Se houver, preencha
          strong  Protocolo número
          |  e
          strong  Protocolo ano
          | .
        li Clique em
          strong  Salvar
          | . Você volta à listagem.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/43-config-cadastros-restritos-lista.png"),
      imgForm: require("@/assets/manuais/43a-config-cadastros-restritos-form.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
